

export class CableProperty {
  public id: number;
  public name: string;
  public resistance: number;  // R1_Ohmkm:
  public capacity: number;  // currentCarryingCapacity_A
  public reactance: number; // X1_Ohmkm
  public capacitance: number; // C1_uFkm
  public R0_Ohmkm: number;
  public X0_Ohmkm: number;
  public C0_uFkm: number;

  /*Resistance_Ohm_km,           //R1_Ohm_km
  Reactance_Ohm_km, //X1_Ohm_km
  Capacitance_uF_km, //C1_uFkm
  Capacity_A //current_carrying_capacity_A*/
}
